import { Stack, Typography } from "@mui/material";
import GCMELogo from "assets/images/gcme-logo.png";
import YotorLogo from "assets/images/logo.png";

export const DenominationSummaryFooter = () => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#1F2937", color: "#01b0b9", borderRadius: 2 }}
      p={3}
      spacing={4}
    >
      <Typography variant="body2">Powered by</Typography>
      <Stack direction="row" alignItems="center" spacing={2}>
        <img src={YotorLogo} alt="Yotor logo" height={28} />
        <img src={GCMELogo} alt="GCME logo" height={28} />
      </Stack>
    </Stack>
  );
};
